const ERROR_CODE = {
  LOGIN_ERROR_WRONG_CREDENTIALS: 1,
  LOGIN_ERROR_MISSING_SKIN: 2,

  AUTH_ERROR_REDIRECT_TO_SKIN: 10,
};

export { ERROR_CODE };
